// extracted by mini-css-extract-plugin
export default {"line":"burger-button_line__R8wzm","label":"burger-button_label__GpWxf","root":"burger-button_root__P-Ahi","isOpen":"burger-button_isOpen__EqU+B"};